// extracted by mini-css-extract-plugin
export default {"root":"FallbackPage_root__wqrxE","content":"FallbackPage_content__IAc96"};